import React from 'react';
import { PublicLayout } from '@/components/Layout/PublicLayout';

export const DisclaimerPage: React.FC = () => {
  return (
    <PublicLayout
      title="Disclaimer"
    >
      <div className="space-y-6 text-sm sm:text-base text-slate-700 leading-relaxed">
        <p className="font-medium text-slate-900 leading-relaxed">
          Yebo Eggs makes reasonable efforts to ensure that the information, product descriptions, prices, photographs and availability shown in the App are accurate and up to date.
        </p>

        <p>
          Product photographs are for illustration purposes and products may vary slightly in appearance, packaging, size or presentation.
        </p>

        <p>
          Prices and product availability may change from time to time. An order may be affected if a product is unavailable or if there is an obvious pricing or system error.
        </p>

        <p>
          Delivery times shown in the App are estimates unless specifically stated otherwise. Delays may occur because of traffic, weather, operational issues, incorrect delivery information or circumstances outside Yebo Eggs' reasonable control.
        </p>

        <p>
          Yebo Eggs does not guarantee that the App will always be available, uninterrupted or free from technical errors.
        </p>

        <p className="font-semibold text-slate-900 border-t border-slate-100 pt-4">
          Nothing in this Disclaimer is intended to remove or limit any rights or remedies that a customer has under applicable South African law.
        </p>
      </div>
    </PublicLayout>
  );
};
